export const itensMenu = [
  {
    key: 0,
    permission: "access_menu_home",
    url: "/",
    title: "Início",
    icon: "HomeOutlined",
  },
  {
    key: 1,
    permission: "access_tic_log",
    url: "/emaillog",
    title: "Logs Email",
    icon: "FileSearchOutlined",
  },
  {
    key: 2,
    permission: "access_tic_params_control",
    url: "/params_control",
    title: "Controle de Parâmetros",
    icon: "ControlOutlined",
  },
];

export default itensMenu;
